<template>
  <div style="margin-top: 113px">
    <v-container>
      <v-card>
        <v-snackbar
          v-model="snackbar"
          :color="snackBarColor"
          :timeout="snackBarTimeout"
        >
          <b>{{ snackBarText }} </b>
        </v-snackbar>
        <v-card-title>
          <div class="my-2">
            <v-btn
              small
              class="mx-2"
              fab
              dark
              color="warning"
              v-on:click="$router.go(-1)"
            >
              <v-icon dark>mdi-arrow-left</v-icon>
            </v-btn>
            <v-btn
              small
              class="mx-2"
              fab
              dark
              color="primary"
              v-on:click="addNew"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </div>
          <v-spacer></v-spacer>
          <div class="text-center country-container">
            <v-select
              v-model="langueToChange"
              :items="refLangue"
              item-text="label"
              item-value="code"
            >
              <template v-slot:selection="{ item }">
                <a href="#" @click.prevent="changeLangue(item)">
                  <img
                    :src="
                      require(`../../assets/${item.code.toUpperCase()}.svg`)
                    "
                  />
                  <button class="ml-2">{{ item.code.toUpperCase() }}</button>
                </a>
              </template>
              <template v-slot:item="{ item }">
                <a href="#" @click.prevent="changeLangue(item)">
                  <img
                    :src="
                      require(`../../assets/${item.code.toUpperCase()}.svg`)
                    "
                  />
                  <button class="ml-2">{{ item.label }}</button>
                </a>
              </template>
            </v-select>
          </div>
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="width: 25%">Num order</th>
                  <th class="text-left" style="width: 25%">Text</th>
                  <th class="text-left" style="width: 25%">URL</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in listRefs"
                  :key="item.code"
                  @click="updateRef(item)"
                >
                  <td>{{ item.numOrder }}</td>
                  <td>{{ item.text }}</td>
                  <td>{{ item.href }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<style>
.margin-top {
  margin-top: 10px;
}

.no-margin {
  margin: 0 !important;
}

.card {
  height: 100vh !important;
}
</style>

<script>
import { mapGetters } from "vuex";
export default {
  name: "RefViewUrl",
  data() {
    return {
      findByName: "",
      langueToChange: null,
      listRefs: [],
      snackbar: false,
      snackBarText: "",
      snackBarColor: "",
      snackBarTimeout: 2000,
      refLangue: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      langue: "auth/langue",
      urlLangue: "getUrlLangue",
    }),
  },
  created() {
    this.langueToChange = this.urlLangue;
    this.fillLanguages();
    this.loadRef();
  },
  mounted: function() {
    this.loadRef();
    if (this.$route.query.add == "ok") {
      this.snackbar = true;
      this.snackBarText = "Saved successfully";
      this.snackBarColor = "success";
      this.$router.push("/refviewurl/urls");
    }
    if (this.$route.query.del == "ok") {
      this.snackbar = true;
      this.snackBarText = "Removed successfully";
      this.snackBarColor = "success";
      this.$router.push("/refviewurl/urls");
    }
  },
  methods: {
    fillLanguages: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api-public/ref/languages", {
        method: "GET",
        credentials: "include",
        headers: myHeaders,
      })
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.refLangue = json.data.map(function(item) {
            return {
              label: item.label,
              code: item.code.toLowerCase(),
            };
          });
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    loadRef: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH +
          "api/ref/" +
          this.$route.params.typeRef +
          "/" +
          this.langueToChange.code.toUpperCase(),
        {
          method: "GET",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.message =
              "If your e-mail address is correct and known by the application,";
            this.message +=
              " an e-mail has been sent with insctructions to reset your password";
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.listRefs = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    addNew: function() {
      this.$router.push("/refaddurl/");
    },
    updateRef: function(item) {
      this.$router.push("/refupdateurl?id=" + item.id);
    },
    changeLangue(langue) {
      this.langueToChange = {
        code: langue.code,
        label: langue.label,
      };
      this.$store.dispatch("loadUrlLangue", this.langueToChange);
      this.loadRef();
    },
  },
};
</script>
